<template>
  <!-- 账号管理设置页面 -->
  <!-- 设置页面的内容区域 -->
  <!-- // 代号 20241212-1  整页-->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->

      <config-title-hang>
        <span slot="config_title_hang_ele2">原设备信息</span>
      </config-title-hang>
      <config-hang>
        <span slot="config_hang_ele2_1"> {{ query.productName }}</span>
        <span slot="config_hang_ele2_2"> 地址:{{ query.borderInnerAddress }} 代码:{{ query.program }}</span>
        <span slot="config_hang_ele3">{{ query.remark }}</span>
        <!-- <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt /> -->
      </config-hang>
      <div class="xiaotishi_style">
        小提示:非专业人士并不建议进行此项操作！</div>
      <div class="xiaotishi_style">
        替换流程:[1,发现了同类可替换设备.2,点击后,会立刻尝试替换.]
      </div>
      <div class="xiaotishi_style">
        若设备代码不一致,请谨慎替换,替换设备成功后,可能会导致一些功能配置出错（如关联场景,按键等）,需手动更新设备相关联的配置信息.
      </div>

      <config-title-hang>
        <span slot="config_title_hang_ele2">发现可替换新设备({{ computedReplaceThreadNewProductListNumber }}台)</span>
        <img slot="config_title_hang_ele5_img" src="~assets/img/config/shuaxin_bai.png" @click="updataBtnHandle" alt />
        <span slot="config_title_hang_ele5" @click="updataBtnHandle">刷新</span>
      </config-title-hang>
      <config-hang @click.native="repalceDeviceBtnHandle(value, index)"
        v-for="(value, index) in oneHostDeviceListData.threadNewProductList" :key="value.threadIp"
        v-if="value.productCode == query.productCode">
        <span slot="config_button_hang_ele5" @click.stop="seekNewThreadDeviceBtnHandle(value.threadIp)">设备定位</span>
        <span slot="config_hang_ele2_1"> {{ value.productName }}</span>
        <span slot="config_hang_ele2_2"> 地址:{{ value.borderInnerAddress }} 代码:{{ value.program }}</span>
        <span slot="config_hang_ele3">点击替换</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>
      <div v-if="computedReplaceThreadNewProductListNumber == 0">
        <div class="xiaotishi_style">
          暂未发现可替换设备哦~
        </div>
        <div class="xiaotishi_style">
          请确保设备已入网后,可尝试点击刷新按钮再次查找.
        </div>
        <div class="xiaotishi_style"></div>
      </div>


    </div>
  </div>
</template>

<script>
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";
import { linePolygonIntersect } from "echarts/lib/util/graphic";
export default {
  data() {
    return {
      oneHostDeviceListData: {
        ////服务器请求到的主机下面的设备列表
        offLineList: [],
        onLineList: [],
        threadNewProductList: []
      },
      oneHostData: {
        ////一个主机的信息
      },
      query: {}
    };
  },
  components: {
    configHang,
    configTitleHang
  },
  methods: {

    updataBtnHandle() {
      ///刷新设备按钮被点击了
      // console.log(this.$route.query.typeId);

      ///获取网关下的产品列表 接口，获取数据
      this.$request({
        method: "post",
        url: "/product/findProductListByGatewayId",
        data: {
          token: this.$store.state.token,
          gatewayId: this.oneHostData.gatewayId,
          typeId: "", ///设备类型id （空的时候所有类型）
          state: 1 ///是否刷底层数据 0:不查 1:查
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            console.log(res.data.data);
            // 排序 20200624
            this.oneHostDeviceListData = res.data.data; ////拿到服务器返回的数据结果

            this.$store.dispatch(
              "asyUpdataoneHostDeviceListData",
              this.oneHostDeviceListData
            ); ///异步提交信息到仓库

            // this.$store.dispatch("asyUpdataServeSceneData", this.ServeSceneData); ///异步提交信息到仓库
            // this.$showTipsToast(1, "获取成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    repalceDeviceBtnHandle(value) {
      let productInfo = {
        oneHostData: this.oneHostData,
        oneHostDeviceListData: this.oneHostDeviceListData,
        threadIp: value.threadIp,
        query: this.query
      };
      console.log(productInfo);
      this.$showTipsToast(24, productInfo);
    },
    seekNewThreadDeviceBtnHandle(threadIp) {

      ///   寻找设备按钮被点击了
      //新产品(未加入系统的产品)定位或取消定位
      this.$request({
        method: "post",
        url: "/product/newThreadProductLocation",
        data: {
          token: this.$store.state.token,
          gatewayId: this.oneHostData.gatewayId,
          threadIp: threadIp,
          state: 1  // 1 开始定位 0 取消定位
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.serveDeviceDetailsData = res.data.data; ////拿到服务器返回的数据结果
            this.$showTipsToast(1, "定位成功~", true, 3000); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
  computed: {

    computedReplaceThreadNewProductListNumber() {
      // 在线设备个数
      let replaceNumber = 0;
      for (let i = 0; i < this.oneHostDeviceListData.threadNewProductList.length; i++) {
        if (this.oneHostDeviceListData.threadNewProductList[i].productCode == this.query.productCode) {
          replaceNumber++;
        }
      }


      return replaceNumber;
    }
  },
  mounted() {
    console.log("mounted阶段");
  },
  created() {
    console.log("created阶段");
    this.query = this.$route.query;
    this.oneHostData = this.$store.state.configinfo.oneHostData; ///拿到仓库当前主机的信息
    this.oneHostDeviceListData = this.$store.state.configinfo.oneHostDeviceListData; ///拿到仓库当前主机下的设备列表
    console.log(this.query);
    console.log(this.oneHostData);
    console.log(this.oneHostDeviceListData);
    //  this.$forceUpdate()  ////强制更新视图
  }
};
</script>

<style>
.device_go_online_btn_corol {
  color: var(--primary-color);
}
</style>
